import {getRandomFutureDate} from "@utils/random-funture-date";

export const FastFoodDeliveryQuoteTestData = {
   // Step 0
   discoveryType: 'Walk-in', // Changed to reflect common online search for specialized insurance
   referrersName: '', // Left blank
   contactOptions: ['email', 'phone'],
   discountCode: 'DELIVERFAST', // Specific discount code for delivery
   
   // Step 1 - Policyholder Information
   title: 'Mr',
   firstName: 'Rohan', // Changed name
   lastName: 'Sharma', // Changed name
   birthDate: '1995-11-08',
   
   houseNumber: '15A',
   addressLine1: 'High Street',
   addressLine2: 'Flat 3',
   
   postCode: 'E1 6AN',
   maritalStatus: 'Single',
   // *** KEY CHANGE: Employment reflects delivery work ***
   employmentStatus: 'Self-Employed',
   
   isHomeOwner: 'No',
   hasChildrenUnder16: 'No',
   numChildrenUnder16: '0',
   
   contactEmail: 'rohan.sharma.delivery@workmail.com',
   contactPhone: '07987654321',
   
   // *** KEY CHANGE: Occupation is delivery-focused ***
   mainOccupation: 'Fast Food Delivery Driver',
   occupationIndustry: 'Food Service/Logistics',
   
   // Step 2 - Driving History
   drivingLicenseType: 'Full UK Manual', // Changed to full license, typical for commercial use
   provideDrivingLicenseNumber: 'Yes',
   britishDrivingLicenseNumber: 'SHARM951108RS3FG',
   drivingLicenseDuration: '5 years',
   drivingLicenseDate: '2015-12-10',
   dvlaMedicalConditions: 'DVLA unaware',
   additionalDrivingQualifications: 'No',
   additionalDrivingQualificationDate: '2020-10-23',
   isBornInUk: 'No',
   lastDateBecameUKResident: '2010-04-01',
   hasNonMotoringCriminalConvictions: 'No',
   nonMotoringCriminalConvictionsDetails: '',
   // Changed to 'Delivery' or 'Courier' as the main usage
   otherCarUsage: 'Delivery/Courier Work',
   
   hasAccidentClaimsInLast5Years: 'Yes',
   motorAccidentsList: [
      {
         date: '2023-01-20',
         type: 'Accident',
         partyAtFault: 'Other party',
         claimCost: '500',
         // Added field relevant to delivery insurance risk
         wasIncidentDuringDelivery: 'Yes',
         wasAccidentSettled : 'Yes'
      }
   ],
   hasMotoringConvictionsInLast5Years: 'No', // Changed to No for variety
   motorConvictionsList: [],
   
   // Step 3 - Vehicle and Usage Info
   isCarRegistrationNumKnown: 'Yes',
   
   carRegistrationNumber: 'FG65JKL',
   carMakeAndModel: 'Toyota Yaris', // Changed to a common, fuel-efficient delivery vehicle
   carEstimatedValue: '4000',
   
   manufacturerName: 'Toyota',
   manufacturerModel: 'Yaris',
   carRegistrationYear: '2015',
   carAlarmsOrImmobiliser: 'Standard Immobiliser',
   carSeatNumber: '5',
   carDoorNumber: '5',
   carEngineSize: '1298',
   carTransmissionType: 'Automatic', // Changed for city driving
   
   hasModifications: 'Yes',
   // *** KEY CHANGE: Modification for delivery ***
   modificationType: 'Vehicle Signage',
   modificationDetails: 'Removable magnetic signage for delivery company.',
   
   wasCarImported: 'No',
   
   carPurchased: 'Yes',
   carPurchaseDate: '2024-01-05',
   
   registeredKeeper: 'Policyholder',
   legalOwner: 'Policyholder',
   isTheCarOnFinance: 'No',
   carImpoundedWithPolice: 'No',
   
   // Car usage
   carParkingAtDay: 'At my home',
   carParkingAtNight: 'Public Road',
   isCarKeptOnSameAddress: 'Yes',
   carKeeperAddress: '',
   
   wasInsuranceDeclinedBefore: 'No',
   insurerName: 'Zego', // Changed to a specialized delivery insurer
   
   // *** KEY CHANGE: Primary usage is Hire & Reward ***
   carUsageType: 'Hire and Reward (Fast Food Delivery)',
   carUsageTypes: ['Hot food Delivery'],
   estimatedAnnualMileage: 'Up to 25000', // Significantly increased mileage for delivery
   
   // *** NEW FIELD: Delivery specific details ***
   primaryDeliveryCompany: 'Deliveroo',
   deliveryVehicleType: 'Car',
   averageWeeklyDeliveryHours: '25-35 hours',
   
   insuranceCoverageType: 'Comprehensive', // Changed to a common option for older commercial vehicles
   noClaimsDiscount: '2 year',
   
   voluntaryExcessAmounts: '250',
   
   insurancePaymentType: 'Annually',
   
   currentOrPreviousInsurerName: 'Admiral',
   renewalPriceOfPreviousInsurer: '1200',
   insuranceCoverageStartDate: getRandomFutureDate({months: 3}),
   
   // Step 4 - Additional Drivers (Modified to be another delivery driver)
   shouldAddAdditionalDrivers: 'No', // Changed to No for simplicity, but fields below show what could be used
   
   additionalDrivers: [
      // Removed additional driver for a cleaner focus on the main driver
   ],
   
   addAdditionalComments: 'I need cover for fast food delivery in central London.',
   
   termsAgreement: 'Yes',
}